"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_system_1 = require("styled-system");
const hooks_1 = require("../../hooks");
const useFormGroup_1 = require("../../hooks/useFormGroup");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
exports.TextInput = react_1.forwardRef((props, ref) => {
    const { colors } = hooks_1.useTheme();
    const { id } = useFormGroup_1.useFormGroup();
    return (jsx_runtime_1.jsx(StyledBox, Object.assign({ as: "input", ref: ref, border: "1px solid rgba(125,125,125,0.5)", fontFamily: "'Roboto', sans-serif !important", borderRadius: 4, lineHeight: 1.45, fontWeight: 300, fontSize: "md", width: "100%", boxShadow: 1, _focus: { boxShadow: '0 0 0 1px ' + colors.selected, borderColor: 'selected' }, _disabled: { backgroundColor: 'rgba(125,125,125,0.1)' }, py: 2, px: 3, id: id, transition: "all 150ms", onChange: (e) => {
            var _a, _b;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
            (_b = props.onChangeValue) === null || _b === void 0 ? void 0 : _b.call(props, e.target.value);
        } }, props), void 0));
});
const StyledBox = tools_1.styled(Box_1.Box) `
  ${styled_system_1.variant({
    variants: {
        error: {
            borderColor: 'danger',
        },
        discreet: {
            border: '1px solid transparent',
            boxShadow: 'none',
        },
        card: {
            border: '1px solid transparent',
            backgroundColor: 'cardBackground',
            color: 'cardText',
            borderRadius: '3px',
            boxShadow: 2,
        },
    },
})}

  outline: none;
`;
//# sourceMappingURL=index.js.map